export function ErrorNotice({ message }: { message: string }) {
  return (
    <div className="error-notice" role="alert">
      <span aria-hidden="true">🧭</span>
      <div>
        <strong>We lost the trail for a moment.</strong>
        <p>{message}</p>
      </div>
    </div>
  );
}
